import { useSyncExternalStore } from "react";
import { subscribePendingImageEdits, pendingImageEditRevision } from "@/lib/pending-image-edits";

export function usePendingImageEditsRevision() {
  return useSyncExternalStore(subscribePendingImageEdits, pendingImageEditRevision, pendingImageEditRevision);
}
